import React, { Component } from 'react';
import _ from 'lodash';
import Validator from 'validatorjs';
import { Row, Col, Modal } from 'react-bootstrap';

import * as XLSX from 'xlsx';
import Loading from '../../../../../facturotopia/loading/Loading';
import ResponseError from '../../../../../shared/responses/ResponseError';
import ResponseResult from '../../../../../shared/responses/ResponseResult';

class CartaPorteMercanciasUploadFile extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      progress: 0,
      show: props.show,
      validator: new Validator({}, this.rules)
    };
  }

  get rules() {
    return {
      'data.*.BienesTransp': ['required', 'numeric'],
      'data.*.ClaveSTCC': ['min:6'],
      'data.*.Descripcion': ['required', 'string', 'min:1', 'max:1000'],
      'data.*.Cantidad': ['required', 'min:0.000001'],
      'data.*.ClaveUnidad': ['required', 'string'],
      'data.*.Unidad': ['string', 'min:1', 'max:20'],
      'data.*.Dimensiones': ['string'],
      'data.*.MaterialPeligroso': ['string', 'in:Sí,No'],
      'data.*.CveMaterialPeligroso': ['string'],
      'data.*.Embalaje': ['string'],
      'data.*.DescripEmbalaje': ['string', 'min:1', 'max:100'],
      'data.*.PesoEnKg': ['required', 'min:0.001'],
      'data.*.ValorMercancia': ['min:0.000000'],
      'data.*.Moneda': ['string'],
      'data.*.FraccionArancelaria': ['numeric'],
      'data.*.UUIDComercioExt': ['string'],
      'data.*.SectorCOFEPRIS': [
        // 'catCartaPorte:c_SectorCOFEPRIS',
        'string'
      ],
      'data.*.NombreIngredienteActivo': [
          'string',
          'min:1',
          'max:1000',
          'regex:/^[^|]{1,1000}$/',
      ],
      'data.*.NomQuimico': [
          'string',
          'min:1',
          'max:150',
          'regex:/^[^|]{1,150}$/',
      ],
      'data.*.DenominacionGenericaProd': [
          'string',
          'min:1',
          'max:50',
          'regex:/^[^|]{1,50}$/',
      ],
      'data.*.DenominacionDistintivaProd': [
          'string',
          'min:1',
          'max:50',
          'regex:/^[^|]{1,50}$/',
      ],
      'data.*.Fabricante': [
          'string',
          'min:1',
          'max:240',
          'regex:/^[^|]{1,240}$/',
      ],
      'data.*.FechaCaducidad': [
          'date',
      ],
      'data.*.LoteMedicamento': [
          'string',
          'min:1',
          'max:10',
          'regex:/^[^|]{1,10}$/',
      ],
      'data.*.FormaFarmaceutica': [
          // 'catCartaPorte:c_FormaFarmaceutica',
          'string'
      ],
      'data.*.CondicionesEspTransp': [
          // 'catCartaPorte:c_CondicionesEspeciales',
          'string'
      ],
      'data.*.RegistroSanitarioFolioAutorizacion': [
          'string',
          'min:1',
          'max:15',
          'regex:/^[^|]{1,15}$/',
      ],
      'data.*.PermisoImportacion': [
          'string',
          'min:1',
          'max:6',
          'regex:/^[^|]{1,6}$/',
      ],
      'data.*.FolioImpoVUCEM': [
          'string',
          'min:1',
          'max:25',
          'regex:/^[^|]{1,25}$/',
      ],
      'data.*.NumCAS': [
          'string',
          'min:1',
          'max:15',
          'regex:/^[^|]{1,15}$/',
      ],
      'data.*.RazonSocialEmpImp': [
          'string',
          'min:1',
          'max:80',
          'regex:/^[^|]{1,80}$/',
      ],
      'data.*.NumRegSanPlagCOFEPRIS': [
          'string',
          'min:1',
          'max:60',
          'regex:/^[^|]{1,60}$/',
      ],
      'data.*.DatosFabricante': [
          'string',
          'min:1',
          'max:600',
          'regex:/^[^|]{1,600}$/',
      ],
      'data.*.DatosFormulador': [
          'string',
          'min:1',
          'max:600',
          'regex:/^[^|]{1,600}$/',
      ],
      'data.*.DatosMaquilador': [
          'string',
          'min:1',
          'max:600',
          'regex:/^[^|]{1,600}$/',
      ],
      'data.*.UsoAutorizado': [
          'string',
          'min:1',
          'max:1000',
          'regex:/^[^|]{1,1000}$/',
      ],
      'data.*.TipoMateria': [
          // 'catCartaPorte:c_TipoMateria',
          'string'
      ],
      'data.*.DescripcionMateria': [
          'string',
          'min:1',
          'max:50',
          'regex:/^[^|]{1,50}$/',
      ]
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnReaderFile = (event) => {
    this.setState({
      progress: 1
    });

    const file = event.target.files[0];
    const fileReader = new FileReader();

    try {
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const bufferArray = e.target.result;
        const xlsx = XLSX.read(bufferArray, { type: "buffer" });
        const name = xlsx.SheetNames[0];
        const sheet = xlsx.Sheets[name];

        let data = XLSX.utils.sheet_to_json(sheet);

        data = this.parseToString(data);

        const validator = this.validate({ data });
        const isValid = validator.passes();

        if (isValid) {
          this.setState({ data: data })

          this.handleOnAdd(data);
        } else {
          let errors = _.map(validator.errors.all(), (error, key) => {
            const fila = key.split('.');

            return _.map(error, (value) => {
              let message = value.replace(`${fila[0]}.${fila[1]}.`, '');
              message = `Fila ${parseInt(fila[1]) + 2}: ` + message;

              return { message: message };
            });
          });

          errors = errors.flat()

          const error = {
            message: 'Error de validación',
            errors: [
              ...errors
            ]
          }

          this.setState({
            showError: true,
            error: error
          });
        }
      }

      event.target.value = null;
    } catch (error) {
      //
    }
  }

  parseToString = (data = {}) => {
    return Object.entries(data).map(([key, value]) => {
      let transform = {};

      for (const key in value) {
        if (Object.hasOwnProperty.call(value, key)) {
          transform[key] = value[key].toString();
        }
      }

      return transform;
    });
  }

  handleOnAdd = (data) => {
    const newData = _.map(data, (item) => {
      let isDetalle = !!item.DetalleUnidadPeso
        || !!item.DetallePesoBruto
        || !!item.DetallePesoNeto
        || !!item.DetallePesoTara
        || !!item.DetalleNumeroPiezas;

      if (isDetalle) {
        item = _.assign(item, {
          DetalleMercancia: {
            UnidadPesoMerc: item.DetalleUnidadPeso,
            PesoBruto: item.DetallePesoBruto,
            PesoNeto: item.DetallePesoNeto,
            PesoTara: item.DetallePesoTara,
            NumPiezas: item.DetalleNumeroPiezas,
          }
        });
      }

      return item;
    });

    this.props.onAdd(newData);

    const result = {
      message: `Se agregaron un total de ${ newData.length } mercancías, se mostrarán en la tabla de mercancias.`
    }

    this.setState({
      progress: 100,
      result: result,
      showResult: true
    });
  }

  handleOnAction = () => {
    this.setState({
      showResult: false,
      showError: false
    });

    this.handleOnClose();

    return;
  }

  handleOnClose = () => {
    this.props.onClose();
  }

  renderResult = () => {
    const { result } = this.state

    return (
      <div className="result-container">
        <ResponseResult
          title="Completado"
          result={ result }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  renderError = () => {
    const { error } = this.state

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  render() {
    const { data, progress, showResult, showError, show } = this.state;

    if (progress === 100 && !!showResult) {
      return this.renderResult();
    }

    if (!!showError) {
      return this.renderError();
    }

    return (
      <Modal backdrop="static" keyboard={ false } show={ show } centered={ true } onHide={ this.handleOnClose }>
        <Modal.Header closeButton>
          <Modal.Title>
            Subir archivo
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <label>
                <input type="file" accept=".csv, .xls, .xlsx" onChange={ this.handleOnReaderFile } />
              </label>

              { (progress > 0 && progress < 100) && !!data && (
                <Row>
                  <Col>
                    <Loading className="mt-3 ml-3" />
                  </Col>
                </Row>
              )}

              <div className="p-3">
                <label>Instrucciones.</label>
                <ul className="list-unstyled">
                  <li>1. <a target="_blank"  href="/resources/template-cartaporte-mercancias.xlsx">Descarga</a> el template</li>
                  <li>2. Sigue la guía de llenado</li>
                  <li>3. Sube el archivo</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    )
  }
}

export default CartaPorteMercanciasUploadFile;
